import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import styles from "./IconButton.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const IconButton = /*#__PURE__*/forwardRef(({
  icon,
  className,
  small,
  toolbar,
  children,
  secondary,
  tertiary,
  ...props
}, ref) => {
  const iconSize = small ? 'SMALL' : 'DEFAULT';
  const classes = classNames(styles.iconButton, {
    [styles.disabled]: props.disabled,
    [styles.small]: small,
    [styles.toolbar]: toolbar,
    [styles.primary]: !secondary && !tertiary,
    [styles.secondary]: secondary && !tertiary,
    [styles.tertiary]: tertiary && !secondary
  }, className);
  return /*#__PURE__*/_jsx("button", {
    ...props,
    ref: ref,
    type: "button",
    className: classes,
    children: icon ? /*#__PURE__*/_jsx(LegacyIconRenderer, {
      icon: icon,
      size: iconSize
    }) : children
  });
});